module.exports = __webpack_public_path__ + "img/au.3d65d882.svg";